import { render, staticRenderFns } from "./horizontal-nav-inicio.vue?vue&type=template&id=12be1f3f"
import script from "./horizontal-nav-inicio.vue?vue&type=script&lang=js"
export * from "./horizontal-nav-inicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports